import has from 'lodash/has'
import isEmpty from 'lodash/isEmpty'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
import {Observable} from 'rxjs/Observable'
import * as Flash from '../../components/flash-message'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

const leadPostFilterSelector: IsActive.FilterSelector = (state: ApplicationState) => state.leadPosts.view.filter
const leadPostdateSelector: any = (state: ApplicationState) => state.contentCalendar.data.selectedDate

const onResetReorderRequest = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Constants.RESET_REORDERED_LEAD_POST)
    .map((action) => Actions.fetchLeadPostsByDate(store.getState().app.selectedCommunity,
      leadPostdateSelector(store.getState())))

const onSuccessfullReorder = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Request.successConstant(Constants.SAVE_REORDERED_LEAD_POST))
  .map((action) => Actions.fetchLeadPostsByDate(store.getState().app.selectedCommunity,
    leadPostdateSelector(store.getState())))

const onSaveRequest = (
  action$: ReduxObservable.ActionsObservable<Form.SaveAction<Types.LeadPost>>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Actions.FormConstants[Form.SAVE])
    .map((action) => Actions.create(store.getState().app.selectedCommunity, action.value))

type AddLeadPostErrorEpic = (action$: ReduxObservable.ActionsObservable<any>) =>
  Observable<Form.SaveCompleteAction>
const addLeadPostError: AddLeadPostErrorEpic = (action$) =>
  action$.ofType(Request.errorConstant(Constants.ADD_LEAD_POST))
    .map(Actions.FormActions[Form.SAVE_COMPLETE])

type AddLeadPostSuccessEpic = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => Observable<Form.SaveCompleteAction | Form.ResetAction | Actions.ToggleModal>
const addLeadPostSuccess: AddLeadPostSuccessEpic = (action$, store) =>
  action$.ofType(Request.successConstant(Constants.ADD_LEAD_POST))
    .mergeMap((action) => {
      const baseActions: any[] = [
        Actions.FormActions[Form.SAVE_COMPLETE](),
      ]
      const leadPostsState = store.getState().leadPosts;
      if (leadPostsState.modal && leadPostsState.modal.isOpen === true && !action.payload.response.retrieved_url) {
        let expectedFields: string[] = []
        if (leadPostsState.form.fields.title === '') {
          expectedFields = expectedFields.concat('Title')
        }
        if (leadPostsState.form.fields.site_name === '') {
          expectedFields = expectedFields.concat('Source')
        }
        if (leadPostsState.form.fields.description === '') {
          expectedFields = expectedFields.concat('Description')
        }
        if (!isEmpty(expectedFields)) {
          return [Flash.showFlashError('Expected fields: ' + expectedFields.join(','))].concat(baseActions)
        }
      } else {
        if (!action.payload.response.retrieved_url) {
          if (has(action.requestAction.options.payload, 'id') && action.requestAction.options.payload.id) {
            return [Flash.showFlashMessage('Post Updated!')].concat(baseActions)
          }
          return [Flash.showFlashMessage('Post created!')].concat(baseActions)
        } else {
          return baseActions
        }
      }
    },
  )

export const epic = ReduxObservable.combineEpics(
  onSaveRequest,
  addLeadPostError,
  addLeadPostSuccess,
  Form.validateForm('leadPosts', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
  Form.validateFormOnOpen('leadPosts', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
  IsActive.createFilterAddedEpic(Constants.ADD_LEAD_POST, Actions.fetchLeadPosts, leadPostFilterSelector),
  IsActive.createFilterChangeEpic(Constants.FETCH_LEAD_POSTS, Actions.fetchLeadPosts, leadPostFilterSelector),
  IsActive.createNavigateToPageEpic(Menu.CONTENT_LEAD_POSTS_URL, Actions.fetchLeadPosts, leadPostFilterSelector),
  IsActive.createNavigateToPageEpic(Menu.CONTENT_CALENDAR_URL, Actions.fetchLeadPostsByDate, leadPostdateSelector),
  IsActive.createDateChangeEpic(IsActive.UPDATE_SELECTED_DATE, Actions.fetchLeadPostsByDate, leadPostdateSelector),
  IsActive.createStatusUpdateEpic(Constants.UPDATE_LEAD_POST, Actions.update),
  onResetReorderRequest,
  onSuccessfullReorder,
)



// WEBPACK FOOTER //
// ./src/pages/lead-posts/epics.ts